import React, { Component } from "react";
import styles from "./HomePage.scss";

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {};

  render() {
    return (
      <div className={styles.HomePage}>
        <p> Homepage </p>
        <a href="/map">Map</a><br/>
        <a href="/calculator">Calculator</a><br/>
        <a href="/careers">Careers</a><br/>
        <a href="/neighbourhoods">Neighbourhoods</a><br/>
        <a href="/survey">Quiz</a><br/>
        <a href="/kingstonhome">KingstonConnect</a><br/>
        {/*
        <div className={styles.Section}>
          <h1>
              <strong>
                  Welcome to the<br />
                  <h2>KingstonHub</h2>
              </strong>
          </h1>
          <p className={styles.Description}>
              Home for everything you may need to know
              about living and working in Kingston,
              Ontario
          </p>
          <div className={styles.Buttons}>
            <Link className={styles.Link} to="/map">
              <div className={styles.ButtonLeft}>
                  <h3>Live</h3>
              </div>
            </Link>
            <Link className={styles.Link} to="/jobs">
              <div className={styles.ButtonRight}>
                  <h3>Work</h3>
              </div>
            </Link>
          </div>
        </div>
        */}
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/HomePage.js